import { Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Layout from './components/Layout'
import Home from './pages/Home'
import SignIn from './pages/SignIn'
import ProjectPage from './pages/ProjectPage'
import AsistanPage from './pages/AsistanPage'
import GautoPage from './pages/GautoPage'
import ProtectedRoute from './components/ProtectedRoute'

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null)

  useEffect(() => {
    // Check authentication status
    const checkAuth = async () => {
      try {
        const response = await fetch('/api/check-auth')
        const data = await response.json() as { authenticated: boolean }
        setIsAuthenticated(data.authenticated)
      } catch (error) {
        console.error('Auth check failed:', error)
        setIsAuthenticated(false)
      }
    }
    checkAuth()
  }, [])

  if (isAuthenticated === null) {
    return <div className="flex min-h-screen items-center justify-center">Loading...</div>
  }

  return (
    <Routes>
      <Route path="/auth/signin" element={<SignIn onLogin={() => setIsAuthenticated(true)} />} />
      <Route
        path="/"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Layout onLogout={() => setIsAuthenticated(false)}>
              <Home />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/project/asistan"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Layout onLogout={() => setIsAuthenticated(false)}>
              <AsistanPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/project/gauto"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Layout onLogout={() => setIsAuthenticated(false)}>
              <GautoPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/project/:id"
        element={
          <ProtectedRoute isAuthenticated={isAuthenticated}>
            <Layout onLogout={() => setIsAuthenticated(false)}>
              <ProjectPage />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
